import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type NoteEditProps = {
    className?: string;
};

const NoteEdit: FunctionComponent<NoteEditProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'note-edit'}
            viewBox="0 0 250 250"
        >
            <path d="M248.5 31.2L212.1 1.4l-26.9 32.8H.3v215.3h218.2V67.9l30-36.7zm-39.1 209.3H9.3V43.2h168.6L88.7 152.1l-.8 36.8 37.1-7 84.4-103v161.6z" />
        </svg>
    );
};
export default NoteEdit;
